import { DefaultTheme } from 'styled-components';

import { colors } from '../colors';
import { Theme } from '../types';

const theme1: DefaultTheme = {
  name: Theme.theme1,

  // Text
  fontFamily: `Quicksand, sans-serif`,
  fontColor: colors.ash,
  fontColorSecondary: colors.charcoal,
  fontWeight: 600,
  fontSize: '14px',
  fontLineHeight: '1.5',
  lineHeight: 'normal',
  errorColor: colors.error,
  iconColor: colors.primary,
  disabledColor: colors.smoke,
  borderRadius: '3px',
  spacing: {
    xsmall: '8px',
    small: '16px',
    medium: '24px',
  },

  // Accordion
  accordionBorderColor: colors.cloud,
  accordionPanelBackgorundColor: colors.pearl,
  accordionDropDownIcon: {
    type: 'caret-down',
    viewSize: 20,
  },

  // BookingCalendar
  bookingCalendarSlotBorderColor: colors.primary,
  bookingCalendarSlotBorderColorActive: colors.primaryBlue,
  bookingCalendarSlotBackgroundColor: colors.white,
  bookingCalendarSlotBackgroundColorHover: colors.primaryOpacity,
  bookingCalendarSlotBackgroundColorActive: colors.primaryOpacity,
  bookingCalendarIconColor: colors.primary,
  bookingCalendarSlotsFontWeight: 600,

  // Button
  buttonFont: `Quicksand, sans-serif`,
  buttonFontSize: {
    xsmall: '16px',
    small: '16px',
    smallmedium: '16px',
    medium: '16px',
    large: '16px',
  },
  buttonFontWeight: 600,
  buttonFocusShadow: `0 0 3px ${colors.primaryHover}`,
  buttonPrimaryTextColor: colors.white,
  buttonPrimaryColor: colors.primary,
  buttonPrimaryHoverTextColor: colors.white,
  buttonPrimaryDisabledTextColor: colors.white,
  buttonPrimaryHoverColor: colors.primaryHover,
  buttonPrimaryDisabledColor: colors.primaryDisabled,
  buttonSecondaryBorderColor: colors.primary,
  buttonSecondaryColor: colors.primary,
  buttonSecondaryBackgroundColor: 'transparent',
  buttonSecondaryHoverColor: colors.primaryHover,
  buttonSecondaryHoverBorderColor: colors.primaryHover,
  buttonSecondaryDisabledColor: colors.primaryDisabled,
  buttonBorderRadius: {
    xsmall: '4px',
    small: '4px',
    medium: '4px',
    large: '4px',
  },
  buttonHeight: {
    xsmall: '32px',
    small: '44px',
    smallmedium: '40px',
    medium: '44px',
    large: '54px',
  },

  // Card
  cardBorderColor: colors.smoke,
  cardPanelBackgorundColor: colors.pearl,

  // Checkbox
  checkboxColor: colors.charcoal,
  checkboxFontWeight: 600,
  checkboxBorderColor: colors.smoke,
  checkboxBorderActiveColor: colors.primary,
  checkboxBackgroundColor: colors.white,
  checkboxBackgroundActiveColor: colors.primary,
  checkboxShadow: colors.primaryHover,
  checkboxHover: colors.primaryHover,
  checkboxLabelIdentation: '24px',

  // Chip
  chipColor: colors.white,
  chipBackgroundColor: colors.primary,

  // DatePicker
  datePickerShowOnlyBottomBorder: false,
  datePickerColor: colors.ash,
  datePickerBorderColor: colors.smoke,
  datePickerSecondaryBorderColor: colors.smoke,
  datePickerPlaceholderColor: colors.smoke,
  datePickerFocusedBorderColor: colors.primary,
  datePickerIconDisabledColor: colors.primaryDisabled,
  datePickerActiveColor: colors.white,
  datePickerActiveBorderColor: colors.primary,
  datePickerActiveBackgroundColor: colors.primary,
  datePickerHoverBackgroundColor: colors.primaryHover,
  datePickerHoverBorderColor: colors.primaryHover,
  datePickerHoverColor: colors.white,
  datePickerHoverShadow: '0 2px 4px 0 rgba(217, 217, 217, 0.5)',
  datePickerIconColor: colors.primary,
  datePickerIconColorHover: colors.primaryHover,
  datePickerPadding: '7px 10px 5px',
  datePickerCalendarIconPadding: '6px 10px',
  datePickerBackgroundColor: colors.white,
  datePickerInputHeight: '34px',
  datePickerTop: '0',

  // DateRangePicker
  dateRangePickerIconColor: colors.primary,
  dateRangePickerDisabledIconColor: colors.smoke,
  dateRangePickerSpanActiveColor: colors.ash,
  dateRangePickerSpanActiveBorderColor: colors.smoke,
  dateRangePickerSpanActiveBackgroundColor: colors.smoke,
  dateRangePickerSpanHoverColor: colors.ash,
  dateRangePickerSpanHoverBorderColor: colors.smoke,
  dateRangePickerSpanHoverBackgroundColor: colors.smoke,

  // Dropdown
  dropdownIconColor: colors.primary,
  dropdownListItemBackgroundColor: colors.pearl,
  dropdownListItemPadding: '8px 20px',
  dropdownIcon: {
    type: 'caret-down',
    viewSize: 20,
  },

  // Footer
  footerTextColor: colors.primaryOpacity,
  footerHeadingColor: colors.edgewater,
  footerCheckIconColor: colors.primary,
  footerSocialIconColor: colors.primaryOpacity,
  footerLineColor: colors.primaryOpacity,
  footerInputErrorColor: colors.error,
  footerIconColor: colors.ash,
  footerBackgroundDark: colors.primaryHover,
  footerBackgroundLight: colors.primaryHover,

  // Form
  formRowLabelColor: colors.charcoal,
  formRowLabelFontSize: '16px',
  formRowLabelFontWeight: '400',
  formRowLabelPadding: '0 0 12px',
  formRowGap: '20px',

  // Heading
  // sizes: 1, 2, 3, 4, 5, 6, 7
  headingSizes: ['70px', '50px', '36px', '30px', '24px', '20px', '16px'],
  headingLineHeight: ['1.1', '1.1', '1.1', '1.1', '1.1', '1.1', '1.1'],
  headingMobileSizes: ['50px', '36px', '30px', '24px', '20px', '18px', '14px'],
  headingOutline: '12px',
  headingOutlineLineHeight: '1.1',
  headingFontFamily: `Quicksand, sans-serif`,
  headingFontWeight: '700',
  headingFontWeightBold: '700',

  // Link
  linkColor: colors.primary,
  linkHoverColor: colors.primaryHover,
  linkDisabledColor: colors.primaryDisabled,

  // LinkButton
  linkButtonIconColor: colors.primary,
  linkButtonIconColorDisabled: colors.primaryDisabled,
  linkButtonIconSize: {
    xsmall: 18,
    small: 18,
    smallmedium: 20,
    medium: 20,
    large: 24,
  },
  linkButtonFontWeight: '600',

  // Modal
  modalLineColor: colors.primary,
  modalIconColor: colors.primary,

  // Nav
  navLinkColor: colors.primary,
  navLinkBackgroundColor: colors.primary,
  navSubMenuItemHoverBackgroundColor: colors.whiteIce,
  navMenuItemBackgroundColor: colors.whiteIce,
  navMobileSignInLinkColor: colors.primary,
  navUserIconBackgroundColor: colors.whiteIce,
  navUserIconColor: colors.primary,
  navMenuHamburgerColor: colors.primary,
  navBorderColor: colors.edgewater,

  // Navbar
  navbarColor: colors.charcoal,
  navbarColorHover: colors.gray,

  // Notification
  notificationBorderColor: colors.smoke,
  notificationBorderRadius: '0',
  notificationColor: {
    info: colors.accentBlue,
    error: colors.error,
    warning: colors.warning,
    success: colors.success,
    neutral: colors.neutral800,
  },
  notificationBackgroundColor: {
    info: `${colors.accentBlue}20`,
    error: `${colors.error}20`,
    warning: `${colors.warning}20`,
    success: `${colors.success}20`,
    neutral: `${colors.neutral600}20`,
  },
  notificationSpacing: '16px',

  // PDF
  pdfPanelBackgroundColor: colors.pearl,
  pdfBorderColor: colors.smoke,
  pdfControlsColor: colors.primary,
  pdfControlsDisabledColor: colors.primaryDisabled,
  pdfIconColor: colors.primary,
  pdfIconDisabledColor: colors.primaryDisabled,
  pdfControlsIconColor: colors.white,

  // Radio
  radioColor: colors.charcoal,
  radioBorderColor: colors.smoke,
  radioBorderActiveColor: colors.primary,
  radioBackgroundColor: colors.white,
  radioBackgroundActiveColor: colors.primary,
  radioShadow: colors.primaryHover,
  radioHover: colors.primaryHover,
  radioSize: 20,
  radioInputTopPosition: 0,

  // Section
  sectionBorderColor: colors.primary,
  sectionIconColor: colors.primary,

  // Select Input
  selectShowOnlyBottomBorder: false,
  selectShowIndicatorAnimation: false,
  selectColor: colors.ash,
  selectPlaceholderColor: colors.smoke,
  selectDisabledColor: colors.smoke,
  selectDisabledBorderColor: colors.cloud,
  selectBorderColor: colors.charcoal,
  selectPrimaryBorderColor: colors.smoke,
  selectPrimaryHoverBorderColor: colors.smoke,
  selectPrimaryFocusedBorderColor: colors.primary,
  selectPrimaryDisabledBackgroundColor: colors.pearl,
  selectPrimaryIndicatorPadding: '7px 8px',
  selectPrimaryBorderRadius: '3px',
  selectPrimaryBackgroundColor: colors.white,
  selectTertiaryBorderColor: colors.smoke,
  selectTertiaryHoverBorderColor: colors.smoke,
  selectTertiaryFocusedBorderColor: colors.primary,
  selectTertiaryDisabledBackgroundColor: 'transparent',
  selectTertiaryIndicatorPadding: '7px 8px',
  selectTertiaryBorderRadius: '3px',
  selectTertiaryBackgroundColor: colors.white,
  selectHoverShadow: '0 2px 4px 0 rgba(217, 217, 217, 0.5)',
  selectInputPadding: '0',
  selectMenuShadow: 'none',
  selectMenuBorder: `1px solid ${colors.cloud}`,
  selectOptionPadding: '16px 10px',
  selectOptionActiveColor: colors.ash,
  selectOptionMultiLineHeight: '1',
  selectOptionMultiMargin: '0',
  selectIndicatorIcon: 'caret-down',
  selectIndicatorSearchIcon: 'search',
  selectIndicatorIconSize: 20,
  selectIndicatorIconViewSize: 20,
  selectIndicatorSeachIconSize: 20,
  selectIndicatorSeachIconViewSize: 20,
  selectIndicatorIconColor: colors.primary,
  selectInputHeight: '34px',

  // Table
  tableIconColor: colors.primary,
  tableBorderColor: colors.cloud,
  tableIconColorDisabled: colors.primaryDisabled,
  tableHeaderTextColor: colors.charcoal,
  tableCellTextColor: colors.ash,
  tableCellSelectedTextColor: colors.darkgray,
  tableRowBackgroundColorHover: colors.smoke,
  tableRowBackgroundColorSelected: colors.primaryOpacity,
  tableRowPrimaryBackgroundColor: colors.white,
  tableRowSecondaryBackgroundColor: colors.pearl,
  tableRowExpandedPrimaryBackgroundColor: colors.palegreen,
  tableRowExpandedSecondaryBackgroundColor: colors.primaryOpacity,
  tablePaginationIconColorDisabled: colors.primaryDisabled,
  tablePaginationIconColor: colors.primary,
  tablePaginationTextColor: colors.primary,
  tablePaginationTextColorActive: colors.ash,
  tablePaginationBackgroundColorActive: colors.primaryOpacity,

  // Tabs
  tabsActiveBorderColor: colors.primary,
  tabsActiveColor: colors.charcoal,
  tabsActiveFontWeight: 700,
  tabsBackgroundColor: colors.riverstone,
  tabsBackgroundColorHover: colors.pearl,
  tabsBorderColor: colors.smoke,
  tabsBorderBottom: '8px',
  tabsBorderTop: '8px',
  tabsDisabledBackgroundColor: colors.pearl,
  tabsDisabledColor: colors.neutral600,
  tabsFontSize: '12px',
  tabsHeight: '58px',
  tabsLetterSpacing: '0.5px',

  // Text Input
  textInputShowOnlyBottomBorder: false,
  textInputColor: colors.ash,
  textInputFocusedColor: colors.charcoal,
  textInputBorderColor: colors.smoke,
  textInputSecondaryBorderColor: colors.smoke,
  textInputFocusedBorderColor: colors.primary,
  textInputBackgroundColor: colors.white,
  textInputHoverShadow: '0 2px 4px 0 rgba(217, 217, 217, 0.5)',
  textInputPadding: '8px 10px',
  textInputPlaceholderColor: colors.smoke,
  textInputLabelColor: colors.darkblue,
  textInputNotePadding: '0',
  textInputNoteFontStyle: 'normal',
  textInputDisabledBorderColor: colors.cloud,
  textInputDisabledColor: colors.smoke,
  textInputDisabledBackgroundColor: colors.pearl,
  textInputShowAnimatedLabel: false,
  textInputIconColor: colors.primary,
  textInputHeight: '36px',
  textInputIconRight: '8px',

  // Textarea Input
  textAreaInputTextColor: colors.ash,
  textAreaInputBorderColor: colors.smoke,
  textAreaInputSecondaryBorderColor: colors.smoke,
  textAreaInputFocusTextColor: colors.charcoal,
  textAreaInputFocusBorderColor: colors.primary,
  textAreaInputDisabledTextColor: colors.smoke,
  textAreaInputDisabledBorderColor: colors.cloud,
  textAreaInputPlaceholderColor: colors.smoke,

  // Toggle
  toggleColor: colors.smoke,
  toggleActiveColor: colors.primary,

  // ToggleButtonGroup
  toggleButtonGroupHeight: {
    xsmall: '24px',
    small: '28px',
    medium: '40px',
    large: '46px',
  },

  // UserDropdown
  userDropdownColor: colors.primary,
  userDropdownColorHover: colors.primaryHover,

  inputErrorMessagePadding: '0',
};

export default theme1;
